import { xRotate } from "../x/index.js";
export function zeroShift(data, inverse) {
    const middle = inverse
        ? Math.ceil(data.length / 2)
        : Math.floor(data.length / 2);
    return xRotate(data, middle);
}
//# sourceMappingURL=zeroShift.js.map